module.exports = __webpack_public_path__ + "static/media/dropdown.f91fe326.svg";